import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white px-5 py-20" data-id="element-25" data-mp="1iwgkuc6jbkay">
      <div className="mx-auto max-w-3xl" data-id="element-26" data-mp="1ixro8aw2iq1j">
        <h2 className="text-center font-display text-[2.1rem] font-semibold uppercase leading-[1.02] tracking-[.01em] text-ink-900 sm:text-5xl" data-id="element-27" data-mp="1nu9q9300kaa6">
          Frequently asked questions
        </h2>
        <div className="mt-10 divide-y divide-line border border-line" data-id="element-28" data-mp="2fmh27q4kqyi8">
          {faqs.map(({
          question,
          answer
        }, index) => {
          const isOpen = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={question} className="bg-stone-50" data-id="element-29" data-mp="26rt1md9y24zr" data-mpi={index}>
                <h3 data-id="element-30" data-mp="2uiycee112737">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={panelId} className="flex w-full items-center justify-between gap-5 px-6 py-5 text-left text-[15px] font-semibold text-ink-900" data-id="element-31" data-mp="2uigc96b8v8q0">
                    <span data-id="element-32" data-mp="25fughwv8xv1m">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-sage-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-33" data-mp="25hnl76mau56z" />
                  </button>
                </h3>
                {isOpen && <div id={panelId} className="px-6 pb-6 text-sm leading-relaxed text-ink-600" data-id="element-34" data-mp="2advyeegxrobi">
                    {answer}
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}